import React, { useState } from "react";
import "./photographersPage.css";
import { Link } from "react-router-dom";

const photographers = [
  { name: "CAN ÇİÇEK", images: ["/images/canCicekPre.jpg"] },
  { name: "EKİN CAN BAYRAKDAR", images: ["/images/ekincanPre.jpg"] },
  { name: "FETHİ KARADUMAN", images: ["/images/fethiPre.jpg"] },
  { name: "MUSTAFA ÇETİN", images: ["/images/mustafaCetinPre.jpg"] },
  { name: "ONUR AYNAGÖZ", images: ["/images/onurAynagozPre.jpg"] },
  { name: "SİNEM YAZICI", images: ["/images/sinemPre.jpg"] },
  { name: "ŞENOL ALTUN", images: ["/images/senolAltunPre.jpg"] },
  { name: "UTKU ATALAY", images: ["/images/utkuPre.jpg"] }
];

const convertToSlug = (str) => {
  const map = {
    ç: "c",
    Ç: "C",
    ş: "s",
    Ş: "S",
    ı: "i",
    İ: "I",
    ü: "u",
    Ü: "U",
    ö: "o",
    Ö: "O",
    ğ: "g",
    Ğ: "G",
  };
  return str
    .split("")
    .map((char) => map[char] || char) // Eğer karakter eşleşiyorsa değiştir, yoksa olduğu gibi bırak
    .join("")
    .toLowerCase()
    .replace(/ /g, "-"); // Boşlukları da tireye çevir
};

const PhotographersPage = () => {
  const [selectedPhotographer, setSelectedPhotographer] = useState(null);

  return (
    <div className="photographers-page">
      <div className="photographer-names">
        {photographers.map((photographer) => (
          <Link
          key={photographer.name}
          to={`/photographers/${convertToSlug(photographer.name)}`} 
          className={`photographer-name ${
            selectedPhotographer === photographer.name ? "filled" : "outlined"
          }`}
          onMouseEnter={() => setSelectedPhotographer(photographer.name)}
          onMouseLeave={() => setSelectedPhotographer(null)}
        >
          {photographer.name}
        </Link>        
        ))}
      </div>
      <div className="photographer-images">
        {selectedPhotographer &&
          photographers
            .find((p) => p.name === selectedPhotographer)
            ?.images.map((image, index) => (
              <img
                key={index}
                src={image} 
                alt={selectedPhotographer}
                className="photographer-image"
              />
            ))}
      </div>
    </div>
  );
};

export default PhotographersPage;
